<template>
  <div
    v-if="hasClip"
    class="clip-reports__table">
    <div class="clip-reports__day-selector">
      <md-field
        class="md-field-year">
        <label for="date">Filter by day (in month):</label>
        <md-select
          id="date"
          name="date"
          v-model="filterDate">
          <md-option value="">-- Select Date --</md-option>
          <md-option
            v-for="(day, index) in daysInMonth"
            :key="'daysInMonth' + index"
            :value="day">
            {{ day }}
          </md-option>
        </md-select>
      </md-field>
      <span
        class="remove-filter text-danger small"
        @click.stop="resetClipsFilter">
      <i class="fa fa-times pr-1" /> Reset Filter
    </span>
    </div>
    <md-table>
      <md-table-row>
        <md-table-head>#</md-table-head>
        <md-table-head>Title</md-table-head>
        <md-table-head>Start Date</md-table-head>
        <md-table-head>Start Time</md-table-head>
        <md-table-head>End Time</md-table-head>
        <md-table-head>Duration</md-table-head>
        <md-table-head>Created Date</md-table-head>
        <md-table-head>User</md-table-head>
      </md-table-row>
      <md-table-row
        v-for="(report, index) in clips"
        :key="index">
        <md-table-cell>{{index + 1}}</md-table-cell>
        <md-table-cell>{{report.title || 'No title'}}</md-table-cell>
        <md-table-cell>{{getDate(report.startedAt)}}</md-table-cell>
        <md-table-cell>{{parseToTime(report.startedAt)}}</md-table-cell>
        <md-table-cell>{{parseToTime(report.endedAt)}}</md-table-cell>
        <md-table-cell>{{parseDuration(report.duration)}}</md-table-cell>
        <md-table-cell>{{getDateTime(report.createdAt)}}</md-table-cell>
        <md-table-cell>
          {{
          !report.creatorUsername
            ? '-'
            : substringTeamName(report.creatorUsername)
          }}
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import {
  getDate,
  getDateTime,
  parseToTime,
  parseDuration,
} from '@/utils';
import { getDaysInMonth, parseISO } from 'date-fns';
import _ from 'lodash';

export default {
  props: {
    clips: {
      type: Array,
    },
    selectedYear: {
      type: Number,
    },
    selectedMonth: {
      type: Number,
    },
  },
  data() {
    return {
      clipsFilter: {},
      filterDate: '',
    };
  },
  computed: {
    baseURL() {
      return process.env.APP_ORIGIN || window.location.origin;
    },
    daysInMonth() {
      const days = getDaysInMonth(new Date(this.selectedYear, this.selectedMonth));
      const daysInMonth = [];
      for (let i = 1; i <= days; i += 1) {
        daysInMonth.push(i);
      }
      return daysInMonth;
    },
    hasClip() {
      return this.clips.length > 0;
    },
    filteredClips() {
      return _.filter(this.clips, this.clipsFilter);
    },
    filterEmpty() {
      return _.isEmpty(this.clipsFilter);
    },
  },
  watch: {
    filterDate() {
      if (this.filterDate === '') {
        this.resetClipsFilter();
      } else {
        let dateNum = this.filterDate;
        if (!Number.isInteger(this.filterDate)) {
          dateNum = parseInt(this.filterDate, 10);
        }
        this.clipsFilter = clip => getDate(parseISO(clip.startedAt)) === dateNum;
        this.filterDate = dateNum;
      }
    },
  },
  methods: {
    getDate,
    getDateTime,
    parseToTime,
    parseDuration,
    getFileURL(report) {
      return `${this.baseURL}/api/clips/${report._id}/files/video.mp4`;
    },
    substringTeamName(fullName) {
      return fullName.split('/')[1];
    },
    resetClipsFilter() {
      this.filterDate = '';
      this.clipsFilter = {};
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables.scss';

.clip-reports__table {
  width: 100%;
  padding: $spacer * 4 0;
  .clip-reports__day-selector {
    display: flex;
    flex-flow: row;
    align-items: center;
    .md-field {
      flex: 0 0 20%;
      margin-right: $spacer;
    }
  }
}
</style>
